/**
 * A single label/value row for rendering a situs (assessor) record.
 */
export interface SitusDisplayRow {
	label: string;
	value: string;
}

/**
 * raw_data is the JSONB a municipal situs sync preserves for the source's
 * fields it could not map to a typed column, keyed by the county's own field
 * labels. Flatten it to display rows so no assessor data the API carries is
 * hidden; blank values are dropped.
 */
export function rawSitusRows(raw: unknown): SitusDisplayRow[] {
	if (raw == null || typeof raw !== "object") {
		return [];
	}
	const rows: SitusDisplayRow[] = [];
	for (const [label, value] of Object.entries(raw as Record<string, unknown>)) {
		if (value == null) continue;
		const text = typeof value === "string" ? value.trim() : String(value);
		if (text === "") continue;
		rows.push({ label, value: text });
	}
	return rows;
}
